<div class="topbar-profile ml-4">
  <p-button class="topbar-profile-button p-link" type="button" pStyleClass="@next"
            styleClass="p-button-outlined p-button-secondary"
            enterClass="hidden"
            enterActiveClass="scalein" leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
    <ng-template pTemplate="content">
      <div style="border-radius: 100%; width: 2.5rem; height: 2.5rem; background-color: #babfc3;"
           class="flex align-items-center justify-content-center">
        <div><i class="pi pi-user ml-2"></i></div>
      </div>
      <div class="profile-details">
        <strong class="profile-name">{{ user.username }}</strong>
      </div>
    </ng-template>
  </p-button>
  <ul
    class="list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-4rem sm:w-12rem mt-2 left-10 top-auto">
    <li>
      <div pRipple
           class="flex p-2 border-round align-items-center hover:surface-hover hover:text-0 transition-colors transition-duration-150 cursor-pointer"
           (click)="openProfile()">
        <i class="pi pi-key mr-3"></i>
        <span>Cambia password</span>
      </div>
      <div pRipple
           class="flex p-2 border-round align-items-center hover:surface-hover hover:text-0 transition-colors transition-duration-150 cursor-pointer"
           (click)="logout()">
        <i class="pi pi-power-off mr-3"></i>
        <span>Esci</span>
      </div>
    </li>
  </ul>
</div>
